import { HttpService } from './http.service'
import { apiRoutes } from '../routing/api-routes'

export const ErrorsService = {
  sendErrorData: (data: { [key: string]: string | boolean }): Promise<void> => {
    return HttpService.post(apiRoutes.logError, data)
  },
}
